import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import useCustomIcon from '@/utilities/composables/useCustomIcon';
import { inject } from 'vue';
import ColorButton from './ColorButton.vue';
import { MenuItemFn } from '../menu-item';


export default /*@__PURE__*/_defineComponent({
  __name: 'ColorSelector',
  setup(__props) {

inject('editor');

const { overrideCommands, revertCommandOverrides } = inject<{
  overrideCommands: (com: MenuItemFn[]) => void;
  revertCommandOverrides: () => void;
}>('menuCommandOverride')!;

const { iconPath, getCustomIconStyle } = useCustomIcon();

function makeColor(color: string, props: Parameters<MenuItemFn>[0]) {
  (makeColor as any).index = (makeColor as any).index ?? 0;
  return {
    icon: 'circle',
    key: (makeColor as any).index++,
    effect() {
      (props.editor.chain().focus() as any).setCellAttribute('stTableColor', color).run();
      revertCommandOverrides();
    },
    customProps: {
      color,
    },
    customButton: ColorButton as any,
  };
}

function toggleSwatches() {
  overrideCommands([
    ({ editor, translate, store }) => [
      {
        icon: 'arrow-left',
        effect: () => {
          revertCommandOverrides();
        },
      },
      makeColor('primary', { editor, translate, store }),
      makeColor('error', { editor, translate, store }),
      makeColor('warning', { editor, translate, store }),
      makeColor('success', { editor, translate, store }),
      makeColor('bluelight', { editor, translate, store }),
      makeColor('indigo', { editor, translate, store }),
      makeColor('purple', { editor, translate, store }),
      makeColor('pink', { editor, translate, store }),
      makeColor('orange', { editor, translate, store }),
      makeColor('gray', { editor, translate, store }),
      {
        icon: 'x',
        tooltip: translate('menu.clear-table-cell-color'),
        effect: () => {
          (editor.chain().focus() as any)
            .setCellAttribute('stTableColor', null)
            .setCellAttribute('backgroundColor', null)
            .run();
          revertCommandOverrides();
        },
      },
    ],
  ]);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "add-card-toolbar-icon px-1 flex items-center justify-center",
    onClick: toggleSwatches
  }, [
    _createElementVNode("em", {
      class: "custom-icons page-toolbar group-hover:bg-icon-hover",
      style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)('color')))
    }, null, 4)
  ]))
}
}

})